"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RouteLink.css");
var react_router_dom_1 = require("react-router-dom");
var RouteLink = (function (_super) {
    __extends(RouteLink, _super);
    function RouteLink(props) {
        return _super.call(this, props) || this;
    }
    RouteLink.prototype.render = function () {
        var _a = this.props, children = _a.children, hasLinkStyle = _a.hasLinkStyle, tag = _a.tag, to = _a.to;
        var linkStyleClassName = hasLinkStyle ? ' p-link p-f-sz-d p-link-def p-t-full-hv-primary50 p-f-w-6' : 'p-link';
        return React.createElement(react_router_dom_1.Link, { to: to, "data-tag": tag, className: linkStyleClassName }, children);
    };
    return RouteLink;
}(React.Component));
RouteLink.defaultProps = {
    hasLinkStyle: true,
    to: '',
    children: [],
    tag: ''
};
exports.RouteLink = RouteLink;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['routing'])
        csod.engine.controls['routing'] = {};
    csod.engine.controls['routing']['RouteLink'] = RouteLink;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["RouteLink"] = [];


//////////////////
// WEBPACK FOOTER
// ../player-routing-controls/controls/RouteLink/index.js
// module id = 290
// module chunks = 0